import React from 'react';

import GlobalStyles from '@mui/material/GlobalStyles';

const ROW_HEIGHT = 62;

const AgGridStyles = () => {
  return (
    <GlobalStyles
      styles={(theme) => ({
        '.ag-theme-dokka': {
          '&&': {
            '--ag-row-height': `${ROW_HEIGHT}px`,
          },

          '&& .ag-row:not(.ag-full-width-row)': {
            maxHeight: ROW_HEIGHT,
          },

          '&& .ag-column-first': {
            borderRadius: '8px 0 0 8px',
            borderLeft: '1px solid var(--ag-border-color)',
          },

          '&& .ag-column-last': {
            borderRadius: '0 8px 8px 0',
            borderRight: '1px solid var(--ag-border-color) !important',
          },

          '&& .ag-center-cols-container': {
            '& .ag-row .ag-cell': {
              padding: theme.spacing(0, 0.5),

              '&:first-child': {
                // add gap for first string column(vendor code)
                paddingLeft: theme.spacing(2),
              },
            },
          },

          // The master-detail expander isn't a data cell — neutralise the focus/selection border
          // (drawn with --ag-range-selection-border-color) so clicking it doesn't draw the blue
          // cell-selection outline. The row card's own border uses --ag-border-color, so it stays.
          '&& .ag-cell.beneficiaries-service-cell': {
            '--ag-range-selection-border-color': 'transparent',
            '&.ag-cell-focus': {
              borderTopColor: 'var(--ag-border-color)',
              borderBottomColor: 'var(--ag-border-color)',
              borderLeftColor: 'var(--ag-border-color)',
              borderRight: 'var(--ag-pinned-column-border)',
            },
          },

          // Inline editing (withholdingTax / validUntil): blend the editor into the row card
          // instead of AG Grid's default floating box (border + shadow), which breaks the row.
          '&& .ag-row .ag-cell.ag-cell-inline-editing': {
            height: ROW_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(0, 0.5),
            border: 'none',
            boxShadow: 'none',
            backgroundColor: 'inherit',
          },

          '&& .ag-full-width-row': {
            borderBottom: 'none',
          },

          // when editing - hide current value of cell
          '&& .ag-cell-popup-editing': {
            opacity: 0,
          },
        },
      })}
    />
  );
};

export default AgGridStyles;
